module.exports = __webpack_public_path__ + "img/money_1.03e42865.svg";